<ion-content class="ion-padding" [fullscreen]="true">
    <div class="info__content">
        @if (imgSrc) {
            <img class="info__content__image" [appCfImage]="imgSrc" />
        }
        <h1 class="info__content__title --xxl" [innerHTML]="title | translate"></h1>
        @if (subtext) {
            <p class="info__content__text --l" [innerHTML]="subtext | translate"></p>
        }
    </div>
</ion-content>

<ion-footer>
    <ion-button class="program-button" (click)="close()">
        <span [innerHTML]="buttonText | translate"></span>
    </ion-button>
</ion-footer>
